var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easyscreen-tooltip"},[_vm._t("default"),(!_vm.container && _vm.open)?_c('easyscreen-tooltip-modal',[_c('div',{ref:"content",staticClass:"easyscreen-tooltip--content"},[_vm._t("tooltip")],2)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }